<ion-spinner *ngIf="isLoading" name="dots"></ion-spinner>
<ng-container *ngIf="!isLoading">
  <ion-buttons>
    <ion-button *ngIf="!hideAddNewPayment" color="success" size="small" 
      (click)="showNewPayment()">
      {{addNewPayment ? 'Cancel' : 'Add payment method'}}
    </ion-button>

    <ion-button color="danger"
    (click)="editPayMethods = !editPayMethods; addNewPayment = false;">
    {{ editPayMethods ? "Cancel" : "Edit" }}
    </ion-button>
  </ion-buttons>
  <ion-grid *ngIf="addNewPayment && options">
    <ion-row>
      <ion-col>
        <ngx-stripe-payment 
          #newPaymentMethodControl
          [elementsOptions]="options"
          [options]="paymentOptions"
          ></ngx-stripe-payment>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button color="success" size="small" (click)="addNewPaymentMethod()">Save Payment Method</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-list *ngIf="!addNewPayment">
    <ion-radio-group (ionChange)="selectPaymentMethod($event)" #paymentMethodRadioGroup>
      <ng-container *ngFor="let method of paymentMethods">
        <ion-item lines="full" class="payment-method">
          <ng-container *ngIf="method.card">
            <ion-img [src]="getCardAssetPath(method)" class="cc-logo" *ngIf="getCardAssetPath(method)" slot="start"/>
            <ion-icon *ngIf="!getCardAssetPath(method)" name="card" slot="start"></ion-icon>
            <ion-text style="color: black; font-size: 1rem; letter-spacing: 2px;">
              &bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;{{ method.card.last4 }}
            </ion-text>  
          </ng-container>
          <ng-container *ngIf="method.us_bank_account">
            <ion-icon name="business" slot="start"></ion-icon>
            <ion-text style="color: black; font-size: 1rem; letter-spacing: 2px;">{{method.us_bank_account.bank_name}}&nbsp;&bull;&bull;&bull;&bull;{{method.us_bank_account.last4}}</ion-text>
          </ng-container>
          <ion-radio slot="end" *ngIf="!editPayMethods" [value]="method"></ion-radio>
          <ion-buttons slot="end" *ngIf="editPayMethods">
            <ion-button
              slot="icon-only"
              class="delete-btn"
              color="danger"
              (click)="deletePayMethod(method)"
              ><ion-icon name="trash-outline"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-item>
      </ng-container>
    </ion-radio-group>
  </ion-list>
</ng-container>
